import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAO0Y6MnbnHt-EfV1ahlwo34WFWrJevdW8",
  authDomain: "todolist-appfirebase.firebaseapp.com",
  databaseURL: "https://todolist-appfirebase-default-rtdb.firebaseio.com",
  projectId: "todolist-appfirebase",
  storageBucket: "todolist-appfirebase.appspot.com",
  messagingSenderId: "327032558570",
  appId: "1:327032558570:web:1d57ea17fd2851fa475893"
};

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

